const slugify = (value) => value.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

document.querySelectorAll('[data-field-guides-article]').forEach((section) => {
  const body = section.querySelector('[data-field-guides-article-body]');
  const list = section.querySelector('[data-field-guides-toc-list]');
  if (!body || !list) return;
  const headings = [...body.querySelectorAll('h2')];
  if (!headings.length) { section.querySelector('[data-field-guides-toc]')?.remove(); return; }
  const usedIds = new Set();
  headings.forEach((heading, index) => {
    const baseId = slugify(heading.textContent) || `section-${index + 1}`;
    let id = baseId; let suffix = 2;
    while (usedIds.has(id) || document.getElementById(id)) { id = `${baseId}-${suffix}`; suffix += 1; }
    usedIds.add(id); heading.id = id;
    const item = document.createElement('li'); const link = document.createElement('a');
    link.href = `#${id}`; link.textContent = heading.textContent; item.append(link); list.append(item);
  });
  const toc = section.querySelector('[data-field-guides-toc]');
  if (toc) {
    const narrowViewport = window.matchMedia('(max-width: 1180px)');
    const syncToc = () => { if (narrowViewport.matches) toc.removeAttribute('open'); else toc.setAttribute('open', ''); };
    syncToc();
    narrowViewport.addEventListener('change', syncToc);
  }
});
